import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ImageUpload from '../../../../../components/global/ImageUpload';
import useAssetImageUpoad from '../../../../../hooks/useAssetImageUpload';

const propTypes = {
  className: PropTypes.string,
  onUploaded: PropTypes.func.isRequired,
};

const CardElementPhotoControlAssetUpload = ({ className, onUploaded }) => {
  const classes = classNames({
    [className]: !!className,
  });

  const { uploading, onUpload, onUploadReset, image } = useAssetImageUpoad({
    onImageUploaded: (_, assetImage) => {
      onUploaded(assetImage);
    },
  });

  return (
    <div className={classes}>
      <ImageUpload
        buttonText="Choose a photo..."
        id="image-upload"
        loading={uploading}
        onImageDismiss={() => {
          onUploadReset();
          onUploaded(null);
        }}
        onInputChange={event => {
          const [file] = event.target.files;
          onUpload(file);
        }}
        image={image}
        className="mb-2"
      />
    </div>
  );
};

CardElementPhotoControlAssetUpload.propTypes = propTypes;

export default CardElementPhotoControlAssetUpload;
